import { Check, Minus } from 'lucide-react'
import './select-button.css'

type SelectButtonProps = {
	selected?: boolean
	partial?: boolean  // For "some selected" state in headers
	onClick: () => void
	className?: string  // For positioning (e.g., absolute in PlayCard)
}

export function SelectButton({ selected, partial, onClick, className }: SelectButtonProps) {
	const stateClass = selected
		? 'select-button--selected'
		: partial
			? 'select-button--partial'
			: ''

	return (
		<button
			onClick={(e) => {
				e.stopPropagation()
				onClick()
			}}
			className={`select-button ${stateClass} ${className ?? ''}`.trim()}
		>
			{selected && <Check className="select-button-icon" />}
			{partial && !selected && <Minus className="select-button-icon" />}
		</button>
	)
}
